import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import * as reducers from './reducers';
import { crashReporter } from './middlewares';

export default function configureStore(initialState) {
  // TODO: Only use redux dev tools in development mode (process.env.NODE_ENV !== 'production')
  const composeEnhancers =
    typeof window !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
      : compose; // add support for Redux dev tools

  const rootReducer = combineReducers(reducers);

  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk, crashReporter))
  );
}
